import { AdType } from '@/modules/adv/types'

import type { HbBidderConfig, AdAuctionSource } from '../types'

const PLAYGAMA_PUBLISHER_IDS: Record<AdAuctionSource, string> = {
    portal: 'playgama-portal',
    export: 'playgama-partners-games',
    'ad-sdk': 'playgama-partners-ad-sdk',
    'msn-ad-sdk': 'msn',
    'wrap-ad-sdk': 'playgama-partners-wrap',
}

const PLAYAGAMA_AD_UNITS: Partial<Record<AdType, string>> = {
    rewarded: 'rewarded',
    interstitial: 'interstitial',
    interstitial_preroll: 'interstitial',
    universal_banner_1: 'advanced_banner',
    universal_banner_short_1: 'advanced_banner',
    universal_banner_2: 'advanced_banner',
}

const PLAYAGAMA_FALLBACK_AD_UNITS: Partial<Record<AdType, string>> = {
    rewarded: 'rewarded_fallback',
    interstitial: 'interstitial_fallback',
    interstitial_preroll: 'interstitial_preroll_fallback',
    universal_banner_1: 'advanced_banner_fallback',
    universal_banner_short_1: 'advanced_banner_fallback',
    universal_banner_2: 'advanced_banner_fallback',
}

const getBannerPlaygamaFallback = (type: AdType) =>
    type in PLAYAGAMA_FALLBACK_AD_UNITS ? PLAYAGAMA_FALLBACK_AD_UNITS[type] : 'banner_fallback'

const getBannerPlaygama = (type: AdType) => (type in PLAYAGAMA_AD_UNITS ? PLAYAGAMA_AD_UNITS[type] : 'banner')

const PLAYGAMA_BASE_PARAMS = {
    env: 'production',
    apiKey: 'portal-key-001',
}

export const PLAYGAMA: HbBidderConfig = {
    bidder: 'playgama',
    params: ({ type, adSource }) => ({
        ...PLAYGAMA_BASE_PARAMS,
        publisherId: PLAYGAMA_PUBLISHER_IDS[adSource],
        adUnitId: getBannerPlaygama(type),
    }),
}

export const PLAYGAMA_FALLBACK: HbBidderConfig = {
    bidder: 'playgama',
    params: ({ type, adSource }) => ({
        ...PLAYGAMA_BASE_PARAMS,
        publisherId: PLAYGAMA_PUBLISHER_IDS[adSource],
        adUnitId: getBannerPlaygamaFallback(type),
    }),
}
